import { Typography } from "@mui/material";
import React from "react";
import NewUpdates from "./NewUpdates";
import LeaderBoardTable from "./LeaderBoardTable";
import { useSelector } from "react-redux";

const RankSection = () => {

  const { Course, Translation } = useSelector((state) => ({
    Course: state.LeaderBoard.course,
    Translation: state.Translation.translation?.LeaderBoard || {},
  }));

  return (
    <>
      <Typography mb={"30px"} fontWeight={500} variant="title" display={"flex"}>
        {Course?.CourseName} |
        <Typography variant="title" color="secondary.light" fontWeight={500}>
          {" "}
          &nbsp; {Course?.RegisteredUser} {Translation?.Students}{" "}
        </Typography>
      </Typography>
      <NewUpdates />
      <LeaderBoardTable />{" "}
    </>
  );
};

export default RankSection;
